module.exports = "/assets/b560e8e8365a32b4dc872324c11f40b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7M.png
// module id = 1116
// module chunks = 0